import { ref, reactive } from 'vue'
import { defineStore } from 'pinia'

export const useAppStore = defineStore('app', () => {
  // 侧边栏状态
  const sidebar = reactive({
    opened: localStorage.getItem('sidebarStatus') ? !!+localStorage.getItem('sidebarStatus') : true,
    withoutAnimation: false
  })
  
  // 设备类型
  const device = ref('desktop')
  
  // 尺寸设置
  const size = ref(localStorage.getItem('size') || 'default')
  
  // 切换侧边栏
  const toggleSidebar = () => {
    sidebar.opened = !sidebar.opened
    sidebar.withoutAnimation = false
    if (sidebar.opened) {
      localStorage.setItem('sidebarStatus', 1)
    } else {
      localStorage.setItem('sidebarStatus', 0)
    }
  }
  
  // 关闭侧边栏
  const closeSidebar = (withoutAnimation = false) => {
    localStorage.setItem('sidebarStatus', 0)
    sidebar.opened = false
    sidebar.withoutAnimation = withoutAnimation
  }
  
  // 切换设备类型
  const toggleDevice = (newDevice) => {
    device.value = newDevice
  }
  
  // 设置尺寸
  const setSize = (newSize) => {
    size.value = newSize
    localStorage.setItem('size', newSize)
  }
  
  return {
    // 状态
    sidebar,
    device,
    size,
    
    // 方法
    toggleSidebar,
    closeSidebar,
    toggleDevice,
    setSize
  }
})
